
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__jobs__",
      function () {
        return require("private-next-pages/__jobs__/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__jobs__"])
      });
    }
  